import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SupervisorComponent } from './supervisor/supervisor.component';
import { TestComponent } from './test/test.component';
const routes: Routes = [
  {
    path: '', redirectTo: 'supervisor', pathMatch: 'full'
  },
  {
    path: 'supervisor', component: TestComponent, data: { title: 'Supervisor' }
  },
  {
    path: 'supervisor/:token/:id', component: TestComponent, data: { title: 'Supervisor Test' }
  }]

  @NgModule({
    imports: [RouterModule.forRoot(routes, {useHash:false})],
    exports: [RouterModule]
  })
  export class AppRoutingModule { }
